import React, {FC} from 'react';
import Chart from 'react-apexcharts'

export interface Data {
  label: string
  amount: number
  earnings: number|null,
  vat: number|null
}

interface Props {
  data: Data[]
}
const CurrentPricingChart: FC<Props> = ({data}) => {

  const categories = data.map(item => item.label)
  const series = [{
    data: data.map((d: Data) => d.amount),
    name: 'Price'
  }, {
    data: data.map((d: Data) => d.earnings),
    name: 'Earnings'
  }, {
    data: data.map((d: Data) => d.vat),
    name: 'VAT'
  }]

  const options: ApexCharts.ApexOptions = {
    chart: {
      id: 'supplier-current-pricing',
      toolbar: { show: false },
      zoom: { enabled: false },
      stacked: true
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: 'end',
        horizontal: true,
      }
    },
    xaxis: {
      categories: categories,
    },
    grid: {
      show: false, // Disable grid lines
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return val.toFixed(4)
        },
      },
    },
  }

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={320}
    />
  )
}

export {CurrentPricingChart}
